export default "__VITE_ASSET__CRI2mlsL__$_?url__"